import React, { useEffect, useState } from 'react';
import ShopItemGroup from './shop-item-group';
const ShopRegion = ({ regionName, shopItemList }) => {
    const [className, setClassName] = useState('shop-items');
    useEffect(() => {
        if (regionName.length > 10) {
            setClassName('shop-items campaign');
        }
    }, [
        regionName
    ]);
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "shop-items-head" }, regionName),
        React.createElement("div", { className: "shop-items-body content gutter" },
            React.createElement(ShopItemGroup, { shopItemList: shopItemList }))));
};
export default ShopRegion;
